import api from '../../schedulerApi';

const useHttpDeleteDeviceDailyModeConfig = () => {
    const del = async (device_id, daily_bp_id, config_id) => {
        try {
            const response = await api.delete_device_daily_mode_config(device_id, daily_bp_id, config_id);
            return response;
        } catch (error) {
            console.error('Error deleting device daily mode config:', error?.response?.data || error.message);
        }
    };

    return del;
};

export default useHttpDeleteDeviceDailyModeConfig;
